var formatCurrency = function (amount, options) {
    var _a;
    var decimalPlaces = (_a = options === null || options === void 0 ? void 0 : options.decimalPlaces) !== null && _a !== void 0 ? _a : 2;
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: decimalPlaces,
        minimumFractionDigits: decimalPlaces,
    });
    return formatter.format(amount);
};

export { formatCurrency };
